
export function createCachedFetcher<T>(
  fetcher: () => Promise<T>,
  ttlMs: number
): () => Promise<T> {
  let cache: { data: T; at: number } | null = null;
  let inFlight: Promise<T> | null = null;

  return function cachedFetch(): Promise<T> {
    const now = Date.now();
    if (cache && now - cache.at < ttlMs) return Promise.resolve(cache.data);
    if (inFlight) return inFlight;

    inFlight = fetcher()
      .then((data) => {
        cache = { data, at: Date.now() };
        return data;
      })
      .finally(() => {
        inFlight = null;
      });

    return inFlight;
  };
}
